import {PublicKey} from "@solana/web3.js";
import {web3} from "@project-serum/anchor";
import fetchWithAuth from "@/plugins/fetch";

export default class FluxBotWalletAdapter {

	version = "0.0.1"

	name = "FluxBot"

	icon = "https://api.fogo.fluxbeam.xyz/public/logo_sm.png"

	url = "https://t.me/fluxbeam_fogo_bot?start=login"

	_baseURI = "https://gateway.fogo.fluxbeam.xyz"

	authToken

	publicKey

	connected = false

	connecting = false

	readyState = "Loadable"

	_listeners = {}

	constructor(wallet, token) {
		this._connect(wallet,token)
	}

	connect(openLogin = true) {
		const fluxAuth = localStorage.getItem("fluxbot:auth");
		if (fluxAuth) {
			const obj = JSON.parse(fluxAuth);
			if (obj.token) {
				const token = obj.token.split(".");
				const jwtPayload = JSON.parse(window.atob(token[1]));

				//Only set if we have valid params
				if (Date.now() < jwtPayload.exp * 1000) {
					return this._connect(new web3.PublicKey(jwtPayload.wallet), obj.token)
				} else {
					localStorage.removeItem("fluxbot:auth")

				}
			}
		}

		//TODO this is fucking annoying
		if (openLogin)
			window.open("https://t.me/fluxbeam_fogo_bot?start=login");

		return false
	}

	_connect(wallet, authToken) {
		this.publicKey = wallet

		if (!authToken)
			return false

		this.authToken = authToken
		this.connected = true
		localStorage.setItem("walletName", "FluxBot")
		return true
	}

	disconnect(e) {
		// console.log("disconnect", e)
	}

	autoConnect(e) {
		// console.log("autoConnect", e)
		return this.connect(false)
	}

	on(...args) {
		// console.log("on", args)
		this._listeners[args[0]] = args[1]
	}

	off(...args) {
		// console.log("off", args)
		delete this._listeners[args[0]]
	}

	login(opts = {
		wallet: "",
		clientID: "",
		signature: "",
		timestamp: "",
	}) {
		return fetchWithAuth(`${this._baseURI}/bot/auth`, {
			method: "POST",
			headers: {
				"Content-Type": "application/json",
			},
			body: JSON.stringify(opts)
		}).then(r => r.json()).then(j => {
			if (j.error) {
				throw new Error(j.error)
			}

			localStorage.setItem("fluxbot:auth", JSON.stringify({wallet: opts.wallet, token: j.token}))
			return this._connect(opts.wallet, j.token)
		})
	}

	async request(action = "", payload = {}, settings = {slippage: 0.25, priorityFee: 0.001, validatorTip: 'market'}) {
		return await fetchWithAuth(`${this._baseURI}/bot/actions`, {
			method: "POST",
			headers: {
				"Content-Type": "application/json",
				"Authentication": `Bearer ${this.authToken}`
			},
			body: JSON.stringify({
				action: action,
				payload: payload,
				settings: settings
			})
		}).then(r => r.json())
	}


	_decodeJwt(token) {
		// Split the token into its parts
		const parts = token.split('.');
		if (parts.length !== 3) {
			throw new Error('Invalid JWT token');
		}

		// Decode the payload from Base64URL
		const payloadBase64Url = parts[1];
		const payloadBase64 = payloadBase64Url.replace(/-/g, '+').replace(/_/g, '/');
		const payloadJson = decodeURIComponent(atob(payloadBase64).split('').map(function(c) {
			return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
		}).join(''));

		// Parse the JSON payload
		const payload = JSON.parse(payloadJson);

		// Return the `exp` claim
		return payload.exp;
	}
}
